module.exports = __webpack_public_path__ + "img/CityDefault.0a5bb85c.png";